import React from 'react'
import ContactIcons from './ContactIcons'


export default function ContactText() {

  const contactGreg =
    {
      "id": 2,
      "title": "Coach",
      "name": "Greg Wegrzynowicz(Text Name Prior to Calling)",
      "email": "Greg@606Academy.com",
      "phone": "3126628256",
      "formattedPhone": "312-662-8256"
    }
   const contactMatthew =
    {
      "id": 1,
      "title": "Coach",
      "name": "Matthew Fields(Text Name Prior to Calling)",
      "email": "matthew@606Academy.com",
      "phone": "7735585739",
      "formattedPhone": "773-558-5739"
    }

   return (
    <div className='contact__container'>
      <div className="am">
        <h3>Contact 606 Academy</h3>
        <div className="text-sm-left text-md-justify text-lg-justify">
          <p>Due to the number of spam calls we are recieving we are asking that our clients and potential clients text us prior to calling so we can verify you are human</p>
          <p>{contactMatthew.title} {contactMatthew.name}</p>
          <ContactIcons name={ contactMatthew }/>           
          <p>
            <a className="contact-text-links" href={`mailto:${contactMatthew.email}?Subject=Hello`}>
              {contactMatthew.email}
            </a>
          </p>
          <p>
            <a className="contact-text-links" href={`tel:${contactMatthew.phone}`}>
              {contactMatthew.formattedPhone}
            </a>
          </p>
      </div>
        <div className="text-sm-left text-md-justify text-lg-justify">
          <p>{contactGreg.title} {contactGreg.name}</p>
          <ContactIcons name={ contactGreg }/>           
          <p>
            <a className="contact-text-links" href={`mailto:${contactGreg.email}?Subject=Hello`}>
              {contactGreg.email}
            </a>
          </p>
          <p>
            <a className="contact-text-links" href={`tel:${contactGreg.phone}`}>
              {contactGreg.formattedPhone}
            </a>
          </p>
      </div>
      </div>
    </div>
   )
}